export enum UserPaymentType {
  None = 0,
  Subscriber = 1,
  Demo = 2,
  NonSubscriber = 4,
  Internal = 8,
  Payment = 16,
  Investor = 32,
  FamilyOffice = 64,
}

// tslint:disable-next-line:no-namespace
export namespace UserPaymentType {
  export function toString(userPaymentType: UserPaymentType): string {
    switch (userPaymentType) {
      case UserPaymentType.None:
        return 'None';
      case UserPaymentType.Subscriber:
        return 'Subscriber';
      case UserPaymentType.Demo:
        return 'Demo';
      case UserPaymentType.NonSubscriber:
        return 'NonSubscriber';
      case UserPaymentType.Internal:
        return 'Internal';
      case UserPaymentType.Payment:
        return 'Payment';
      case UserPaymentType.Investor:
        return 'Investor';
      case UserPaymentType.FamilyOffice:
        return 'FamilyOffice';
      default:
        return null;
    }
  }

  export function listAll() {
    return [UserPaymentType.None, UserPaymentType.Subscriber, UserPaymentType.Demo, UserPaymentType.NonSubscriber,
      UserPaymentType.Internal, UserPaymentType.Payment, UserPaymentType.Investor, UserPaymentType.FamilyOffice];
  }

  export function parse(userPaymentTypeStr: string): UserPaymentType {
    return UserPaymentType[userPaymentTypeStr];
  }
}

export default UserPaymentType;
